export default {
      id: "facebook-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "./images/icons.svg#facebook",
      toString: function () {
        return this.url;
      }
    }